/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import {REMOVE_GROUP_REQUEST, REMOVE_GROUP_SUCCESS, REMOVE_GROUP_FAILURE} from "../../types";

const DeleteGroupAction = (idGroup) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/group/${idGroup}`
        },
        method: 'DELETE',
        headers: (headers()),
        types: [
            REMOVE_GROUP_REQUEST,
            {
                type: REMOVE_GROUP_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": REMOVE_GROUP_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: REMOVE_GROUP_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": REMOVE_GROUP_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {DeleteGroupAction}